import basePageFields from '@fragments/pages/basePageFields';

export default gql`
    fragment TagFragment on Tag {
        ${basePageFields}
        searchIndexVisibility
    }
`;
